import React, { useContext } from "react";
import Chart from "react-apexcharts";

import axios from "axios";
import { useState, useEffect } from "react";
import Global, { isAdminAccount, isBusinessAccountType } from "../util/Global";
import { useTranslation } from "react-i18next";
import { LoaderComponent } from "../util/Loader";
import { DashboardHeaderContext } from "../components/DashboardHeader";
import { CurrencyContext, filterSaleByRetailer } from "../components/Utils";
import { GlobalData } from "../util/GlobalData";
// import { moveFile } from "move-file";
// const moveFile = require("@npmcli/move-file");
// const cpFile = require("cp-file");
const LIST_CHIFFRES_URL = Global.backend + "/index.php/api/dashboard/chiffreparproduit";
const LIST_PRODUIT_URL = Global.backend + "/index.php/api/dashboard/produitpluscommander";
const SALES_URL = Global.backend + "/index.php/api/commande/showSales";
const ORDERSURL = Global.backend + "/index.php/api/commande/showOrders";


const DashboardUser = () => {
  const { t, i18n } = useTranslation();

  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)

  useEffect(() => {
    setpageNavLink(isAdminAccount() ? { path: "/dashboard/admin", label: "adminDashboard" } : { path: "/", label: "homePage" })
    setpageTitle("navigation12.1")
    setalertTitle("")
    setnavLinks([])
  }, [])

  const [isLoading, setisLoading] = useState(true)


  const [lastSales, setlastSales] = useState([]);
  const [lastOrders, setlastOrders] = useState([]);

  const [totalSold, settotalSold] = useState(0);
  const [lastSold, setlastSold] = useState(0);

  const [totalPurchase, settotalPurchase] = useState(0);
  const [lastPurchase, setlastPurchase] = useState(0);

  const [countcommande, setCountcommande] = useState(0);
  const [countachat, setCountachat] = useState(0);

  const [options, setOptions] = useState()
  const [series, setSeries] = useState([])

  const [donutOptions, setDonutOptions] = useState();
  const [donutSeries, setDonutSeries] = useState([]);
  const { currency, getCurrencyPrice } = useContext(CurrencyContext)
  const [statDunutResponse, setstatDunutResponse] = useState()
  const [sales, setSales] = useState([])
  const [orders, setOrders] = useState([])


  useEffect(() => {
    setisLoading(true)

    axios.all([
      axios.get(LIST_CHIFFRES_URL),
      axios.get(LIST_PRODUIT_URL),
      axios.post(SALES_URL),
      axios.post(ORDERSURL)
    ]).then(axios.spread((statDunutResponse, statResponse, salesResponse, ordersResponse) => {
      fetchStatDunut(statDunutResponse)
      fetchStat(statResponse)
      setSales(salesResponse.data.map((sale) => {
        return filterSaleByRetailer(sale, getCurrencyPrice)
      }))
      setOrders(ordersResponse.data)
      setstatDunutResponse(statDunutResponse)

      setCountcommande(salesResponse.data.length)
      setCountachat(ordersResponse.data.length)

      setisLoading(false)
    }))
  }, []);



  useEffect(() => {
    if (isLoading) {
      return
    }


    fetchStatDunut(statDunutResponse)

    if (!isBusinessAccountType()) {
      calculate(orders, true)
    } else {
      calculate(sales)
    }


  }, [currency, sales, orders]);




  function calculate(salesOrders, isOrder) {
    for (let a = salesOrders.length - 1; a >= 0; a--) {
      if (salesOrders[a].statut_commande == "paid") {
        if (isOrder) {
          setlastPurchase(getCurrencyPrice(salesOrders[a].totale, salesOrders[a].currency))

        } else {
          setlastSold(getCurrencyPrice(salesOrders[a].totale, salesOrders[a].currency))
        }
        break
      }
    }

    const lastSalesOrders = []
    for (let a = salesOrders.length - 1; a >= salesOrders.length - 5 && a >= 0; a--) {
      lastSalesOrders.push(salesOrders[a])
    }



    let totalGain = 0
    salesOrders.map((sale) => {
      if (sale.statut_commande == "paid") {
        totalGain += Number(getCurrencyPrice(sale.totale, sale.currency))
      }
    })
    settotalSold(totalGain.toFixed(2))


    if (isOrder) {
      setlastOrders(lastSalesOrders)
      settotalPurchase(totalGain.toFixed(2))

    } else {
      setlastSales(lastSalesOrders)
      settotalSold(totalGain.toFixed(2))

    }
  }









  function fetchStat(response) {
    if (!response.data.length) {
      return
    }

    const categoriesstat = []
    const dataforstat = []

    response.data.map((data) => {
      categoriesstat.push(data.nom);
      dataforstat.push(data.count);
      // vu.push(data.produit.vu);
    });




    setOptions({
      chart: {
        id: "basic-bar",
      },
      xaxis: {
        categories: categoriesstat,
      },
      dataLabels: {
        enabled: false
      }
    });
    setSeries([
      {
        name: t("NbSales"),
        data: dataforstat,
      },
    ]);

  }







  function fetchStatDunut(response) {
    if (!response.data.length) {
      return
    }

    const categoriesstat = [];
    const tmp_dataforstat = [];


    response.data.forEach((data) => {
      if (!categoriesstat.includes(data.nom)) {
        categoriesstat.push(data.nom)
      }


      tmp_dataforstat.push({ ...data, sum: getCurrencyPrice(data.sum, data.currency) })
    })






    const dataforstat = Object.values(tmp_dataforstat.reduce((acc, item) => {
      const productName = item.nom
      const productSum = parseFloat(item.sum)

      if (!acc[productName]) {
        acc[productName] = productSum
      } else {
        acc[productName] += productSum
      }

      return acc
    }, {}))





    setDonutOptions({
      chart: {
        id: "basic-donut",
        type: "donut",
      },
      labels: categoriesstat,
      dataLabels: {
        enabled: true,

      },
      tooltip: {
        enabled: true,
        y: {
          formatter: function (val, opts) {
            return `${GlobalData.currency[currency]} ${val.toFixed(2)}`;
          },
        },
      },
    });


    setDonutSeries(dataforstat);
  }








  return (
    <LoaderComponent isLoading={isLoading}>

      <div className="container-fluid">
        <div className="row">
          {isBusinessAccountType() &&

            <div className="col-xl-8">
              <div className="card">
                <div className="card-body">
                  <h4 className="header-title mb-2">{t("NbSales")}</h4>
                  <div className="row align-items-center">
                    <div className="col-xl-12">
                      {series.length ?
                        <div className="mixed-chart">
                          <Chart
                            options={options}
                            series={series}
                            type="bar"
                            width="600"
                          />
                        </div>
                        :
                        <div
                          style={{ height: 150 }}
                          className="d-flex align-items-center justify-content-center"
                        >
                          <h3>{t("noData")}</h3>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>


              <div className="card">
                <div className="card-body">
                  <h4 className="header-title mb-4">
                    {t("mostViewedProducts")}
                  </h4>
                  <div className="donut d-flex align-items-center justify-content-center">
                    {donutSeries.length ?
                      <div className="mixed-chart">
                        <Chart
                          options={donutOptions}
                          series={donutSeries}
                          type="donut"
                          width="600"
                        />
                      </div>
                      :
                      <div
                        style={{ height: 150 }}
                        className="d-flex align-items-center justify-content-center"
                      >
                        <h3>{t("noData")}</h3>
                      </div>
                    }

                  </div>
                </div>
              </div>
            </div>
          }



          <div className="col-xl-4">
            <div className="row">
              <div className="col-xl-6 col-md-6">
                <div className="card">
                  <div className="card-body">
                    <div className="text-center">
                      <p className="font-size-20">{t("purchases")}</p>
                      <div className="mini-stat-icon mx-auto mb-3 mt-3">
                        <span className="avatar-title rounded-circle bg-soft-primary">
                          <i className="mdi mdi-cart-outline font-size-20"></i>
                        </span>
                      </div>
                      <h5 className="font-size-18">{countachat}</h5>
                    </div>
                  </div>
                </div>
              </div>


              {isBusinessAccountType() &&
                <div className="col-xl-6 col-md-6">
                  <div className="card">
                    <div className="card-body">
                      <div className="text-center">
                        <p className="font-size-20">{t("salesLabel")}</p>
                        <div className="mini-stat-icon mx-auto mb-3 mt-3">
                          <span className="avatar-title rounded-circle bg-soft-success">
                            <i className="mdi mdi-cash-multiple font-size-20"></i>
                          </span>
                        </div>
                        <h5 className="font-size-18">{countcommande}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              }





              <div className="col-xl-6 col-md-6">
                <div className="card">
                  <div className="card-body">
                    <div className="text-center">
                      <p className="font-size-20">{t(isBusinessAccountType() ? "totalGain" : "totalPurchase")}</p>
                      <div className="mini-stat-icon mx-auto mb-3 mt-3">
                        <span className="avatar-title rounded-circle bg-soft-success">
                          <i className="mdi mdi-bank font-size-20"></i>
                        </span>
                      </div>
                      <h5 className="font-size-18">{GlobalData.currency[currency]} {isBusinessAccountType() ? totalSold : totalPurchase}</h5>
                    </div>
                  </div>
                </div>
              </div>


              <div className="col-xl-6 col-md-6">
                <div className="card">
                  <div className="card-body">
                    <div className="text-center">
                      <p className="font-size-20">{t(isBusinessAccountType() ? "lastGain" : "lastPurchase")}</p>
                      <div className="mini-stat-icon mx-auto mb-3 mt-3">
                        <span className="avatar-title rounded-circle bg-soft-primary">
                          <i className="mdi mdi-cash-multiple font-size-20"></i>
                        </span>
                      </div>
                      <h5 className="font-size-18">{GlobalData.currency[currency]} {isBusinessAccountType() ? lastSold : lastPurchase}</h5>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>










          <div>
            <div className="card" >
              <div className="card-body">
                <h4 className="header-title mb-4">
                  {t(isBusinessAccountType() ? "lastSales" : "lastOrders")}
                </h4>
                {(isBusinessAccountType() ? lastSales : lastOrders).length > 0 && (
                  <div>
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">{t("reference")}</th>
                          <th scope="col">{t("createdAt")}</th>
                          <th scope="col">{t("total")}</th>
                          <th scope="col">{t("paymentMethod")}</th>
                          <th scope="col">{t("paymentStatus")}</th>
                        </tr>
                      </thead>
                      <tbody>

                        {(isBusinessAccountType() ? lastSales : lastOrders).map((comm, index) => {
                          return (
                            <tr key={index}>
                              <td >{comm.reference}</td>
                              <td>{comm.created_at}</td>
                              <td>{GlobalData.currency[currency]}{getCurrencyPrice(comm.totale, comm.currency)}</td>
                              <td>{t("paymentMethods."+comm.methode_de_paiement)}</td>
                              <td>{t("salesOrders.statusOrder." + comm.statut_commande)}</td>
                            </tr>
                          )

                        })}



                      </tbody>
                    </table>
                  </div>
                )}


                {(isBusinessAccountType() ? lastSales : lastOrders).length == 0 && (

                  <div
                    style={{ height: 150 }}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <h3>{t("noData")}</h3>
                  </div>



                )}
              </div>
            </div>



          </div>











        </div>
      </div>
    </LoaderComponent>
  );
};

export default DashboardUser;
